( function () {
   
    'use strict';

    ( function ( $ ) {
        if($('.years-images-slider-section').length){
        $(".club-images-slider").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            infinite:false,
            centerMode:true,
            centerPadding:'25%',
            asNavFor: ".club-years-slider",
            responsive: [
              {
                  breakpoint: 1023,
                  settings: {
                    centerPadding:'18%',
                  }
              },
              {
                  breakpoint:767,
                  settings: {
                    centerPadding:'10%',
                  }
              }
              ]
          });
          $(".club-years-slider").slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: ".club-images-slider",
            dots: false,
            infinite:false,
            centerMode:true,
            centerPadding:'30px',
            arrows: true,
            focusOnSelect: true,
            responsive: [
              {
                  breakpoint: 1023,
                  settings: {
                    centerPadding:'30px',
                  }
              },
              {
                  breakpoint:767,
                  settings: {
                    centerPadding:'10px',
                    slidesToShow: 3,
                  }
              }
              ]
          });
        }
          
    } )( jQuery );
} )();

